import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useContainerInfoLogic, {
  ContainerInfoComponentProps,
} from './useContainerInfoLogic';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    instructionsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: 62,
    },
    instructionsText: {
      fontSize: 26,
      lineHeight: '26px',
      marginTop: '2px',
      height: 26,
      fontWeight: 400,
      display: 'flex',
      justifyContent: 'flex-start',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      width: '100%',
      alignItems: 'flex-end',

      '& span': {
        marginLeft: theme.spacing(1),
      },
    },
    disabledButton: {
      display: 'none',
    },
    navButton: {
      height: 20,
      cursor: 'pointer',
      lineHeight: '4px',
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
      borderRadius: 5,
      padding: theme.spacing(1),
      fontSize: 10,
      transition: 'all 300ms ease-in-out',

      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
    },
  });
});

export const ContainerInfoComponent = ({
  handleAdvancedViewClick,
  handleQueryLibraryClick,
}: ContainerInfoComponentProps) => {
  const classes = useStyles();
  return (
    <div className={classes.instructionsContainer}>
      <Typography variant="h3" className={classes.instructionsText}>
        Search for Anything
      </Typography>
      <div className={classes.buttonContainer}>
        <span className={classes.navButton} onClick={handleAdvancedViewClick}>
          Go to Search App
        </span>
        <span
          className={clsx(classes.navButton, classes.disabledButton)}
          onClick={handleQueryLibraryClick}
        >
          Query Library
        </span>
      </div>
    </div>
  );
};

export default MockHook.withHookHoc(
  ContainerInfoComponent,
  useContainerInfoLogic
);
